export default "__VITE_ASSET__DdocYhTj__"